import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { parse_query_string } from './Utils';

async function render() {
  const query_dict = parse_query_string();
  console.log('query dict', query_dict);

  async function fetch_and_rerender() {
    ReactDOM.render(
      React.createElement(App, {}),
      document.getElementById('main')
    );
  }

  await fetch_and_rerender();
}

render();
